import { Grid, Typography } from "@mui/material"

const BannerReport = ({color,name,number}) => {
    return (
    <Grid container sx={{alignItems:"stretch"}}>
        <Grid display={"flex"} flexDirection={"column"} alignItems={"center"} size={12} sx={{padding:"20px 48px", backgroundColor:color}}>
            <Typography variant="h5" fontWeight={600} color="white">Section {number}</Typography>
            <Typography variant="h5" fontWeight={400} color="white" dangerouslySetInnerHTML={{ __html: name }}/>
        </Grid>
    </Grid>    
    )
}

export default BannerReport